(() => {
  if (window.__blossomSearchFocusLoaded) return;
  window.__blossomSearchFocusLoaded = true;

  const getElements = () => {
    const form = document.querySelector('.blossom-desktop-search-form');
    const header = form?.closest('.blossom-header') || document.querySelector('.blossom-header');
    const headerWrapper = header?.closest('.header-wrapper');
    let overlay = document.querySelector('.blossom-search-focus-overlay');
    let highlight = document.querySelector('.blossom-search-focus-highlight');

    if (!overlay && headerWrapper) {
      overlay = document.createElement('div');
      overlay.className = 'blossom-search-focus-overlay';
      overlay.setAttribute('aria-hidden', 'true');
      headerWrapper.appendChild(overlay);
    }

    if (!highlight && headerWrapper) {
      highlight = document.createElement('div');
      highlight.className = 'blossom-search-focus-highlight';
      highlight.setAttribute('aria-hidden', 'true');
      headerWrapper.appendChild(highlight);
    }

    return {
      form,
      input: form?.querySelector('.blossom-desktop-search__input'),
      header,
      headerNavigation: header?.querySelector('.header__inline-menu'),
      overlay,
      highlight,
    };
  };

  const updatePosition = () => {
    const { header, headerNavigation } = getElements();
    if (!header || !headerNavigation) return;

    const headerTop = Math.max(0, header.getBoundingClientRect().top);
    const navigationTop = Math.max(headerTop, headerNavigation.getBoundingClientRect().top);
    document.documentElement.style.setProperty('--blossom-search-header-top', `${headerTop}px`);
    document.documentElement.style.setProperty('--blossom-search-nav-top', `${navigationTop}px`);
  };

  const close = () => {
    const { overlay, highlight } = getElements();
    document.documentElement.classList.remove('blossom-search-open');
    if (overlay) overlay.hidden = true;
    if (highlight) highlight.hidden = true;
  };

  const open = () => {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    const { overlay, highlight } = getElements();
    updatePosition();
    document.documentElement.classList.add('blossom-search-open');
    if (overlay) overlay.hidden = false;
    if (highlight) highlight.hidden = false;
  };

  document.addEventListener('click', (event) => {
    const searchButton = event.target.closest('.blossom-desktop-search__button');
    if (searchButton) {
      event.preventDefault();
      open();
      getElements().input?.focus({ preventScroll: true });
      return;
    }

    if (event.target.closest('.blossom-search-focus-overlay')) close();
  });

  document.addEventListener('focusin', (event) => {
    if (event.target.closest('.blossom-desktop-search__input')) open();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });

  window.addEventListener('resize', () => {
    if (document.documentElement.classList.contains('blossom-search-open')) updatePosition();
  });
})();
